import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { MEDIA, WAVYLINE } from '@constants';
import { TextVariant, Typography } from './Typography';

type Props = {
  background?: string;
  title: string;
  logos: string[];
  highlightedLogoImage: string;
  highlightedLogoText: string;
};

const Logos: React.FC<Props> = ({ background, title, logos, highlightedLogoImage, highlightedLogoText }) => {
  return (
    <Wrapper $background={background}>
      <Typography $variant={TextVariant.Heading4} $mobileVariant={TextVariant.Heading5}>
        {title}
      </Typography>
      <CertificationsWrapper>
        <CertIconsRow>
          {logos.map((logo) => (
            <CertIcon key={logo} src={logo} />
          ))}
        </CertIconsRow>
        <WavyLine src={WAVYLINE} />
        <HighlightedLogo>
          <CertIcon src={highlightedLogoImage} />
          <Typography $variant={TextVariant.BodyRegularMD} $mobileVariant={TextVariant.BodyRegularSM}>
            {highlightedLogoText}
          </Typography>
        </HighlightedLogo>
      </CertificationsWrapper>
    </Wrapper>
  );
};

export default Logos;

const Wrapper = styled.div<{ $background?: string }>`
  background: ${(props) => props.$background || Colors.mint50};
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  align-items: center;
  padding: 96px 32px;

  > p {
    text-align: center;
    max-width: 90vw;
  }

  ${MEDIA.mobileL} {
    padding: 56px 32px;
  }
`;

const CertificationsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  row-gap: 24px;
  align-items: center;
  max-width: 90vw;

  ${MEDIA.tablet} {
    flex-direction: column;
    row-gap: 32px;
  }
`;

const CertIconsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 24px;
  align-items: center;

  ${MEDIA.laptopM} {
    flex-wrap: wrap;
    justify-content: center;
    column-gap: 32px;
    row-gap: 16px;
  }
`;

const WavyLine = styled.img`
  height: 2px;
  width: auto;
  transform: scale(1.5);
  clip-path: inset(0 25% 0 25%);
  rotate: 90deg;

  ${MEDIA.tablet} {
    width: 70%;
    rotate: 0deg;
    height: 4px;
    transform: scale(2);
  }

  ${MEDIA.mobileL} {
    clip-path: none;
    transform: scale(1.5);
  }
`;

const CertIcon = styled.img`
  height: 80px;
  width: auto;

  ${MEDIA.tablet} {
    height: 64px;
  }
`;

const HighlightedLogo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 23px;

  > p {
    max-width: 280px;
  }
`;
